<template>
	<table class="table table-config">
		<thead>
			<tr>
				<th colspan="11">{{title}}</th>
			</tr>
			<tr>
				<th rowspan="2"></th>
				<th colspan="5">2D</th>
				<th colspan="3">3D</th>
				<th colspan="2">4D</th>
			</tr>
			<tr>
				<th>Đầu đuôi</th>
				<th>7 lô</th>
				<th>Bao lô</th>
				<th>Đá thẳng</th>
				<th>Đá Xiên</th>
				<th>Đầu đuôi</th>
				<th>7 lô</th>
				<th>Bao lô</th>
				<th>Đuôi</th>
				<th>Bao lô</th>
			</tr>
		</thead>
		<tbody>
			<tr>
				<th scope="row">Bắc</th>
				<td v-for="prop in limitBacHeader" :style="[1,3,4,6,8,9,11,12,14,17].indexOf(prop)<0?'display:none;':''" :class="'value_'+type">
					<input class="form-control form-control-sm m-input" v-if="(prop == 1 || prop == 2) && (typeof limitConfig['_1'] !== 'undefined') && (typeof limitConfig['_1'][prop] !== 'undefined')" :propId="prop" gameId="1" :origin="limitConfig['_1'][prop][type]" v-model="mb2ddauduoi" />
					<input class="form-control form-control-sm m-input" v-else-if="(prop == 6 || prop == 7) && (typeof limitConfig['_1'] !== 'undefined') && (typeof limitConfig['_1'][prop] !== 'undefined')" :propId="prop" gameId="1" :origin="limitConfig['_1'][prop][type]" v-model="mb3ddauduoi" />
					<input class="form-control form-control-sm m-input" v-else-if="(typeof limitConfig['_1'] !== 'undefined') && (typeof limitConfig['_1'][prop] !== 'undefined')" :propId="prop" gameId="1" :origin="limitConfig['_1'][prop][type]" v-model="mbOther[prop]" />
				</td>
			</tr>
			<tr>
				<th scope="row">Trung</th>
				<td v-for="prop in limitNamHeader" :style="[1,3,5,6,8,9,10,11,12,14,13,17].indexOf(prop)<0?'display:none;':''" :class="'value_'+type">
					<input class="form-control form-control-sm m-input" v-if="(prop == 1 || prop == 2) && (typeof limitConfig['_4'] !== 'undefined') && (typeof limitConfig['_4'][prop] !== 'undefined')" :propId="prop" gameId="4" :origin="limitConfig['_4'][prop][type]" v-model="mt2ddauduoi" />
					<input class="form-control form-control-sm m-input" v-else-if="(prop == 6 || prop == 7) && (typeof limitConfig['_4'] !== 'undefined') && (typeof limitConfig['_4'][prop] !== 'undefined')" :propId="prop" gameId="4" :origin="limitConfig['_4'][prop][type]" v-model="mt3ddauduoi" />
					<input class="form-control form-control-sm m-input" v-else-if="(typeof limitConfig['_4'] !== 'undefined') && (typeof limitConfig['_4'][prop] !== 'undefined')" :propId="prop" gameId="4" :origin="limitConfig['_4'][prop][type]" v-model="mtOther[prop]" />
				</td>
			</tr>
			<tr>
				<th scope="row">Nam</th>
				<td v-for="prop in limitNamHeader" :style="[1,3,5,6,8,9,10,11,12,14,13,17].indexOf(prop)<0?'display:none;':''" :class="'value_'+type">
					<input class="form-control form-control-sm m-input" v-if="prop == 17 && (typeof limitConfig['_3'] !== 'undefined') && (typeof limitConfig['_3'][prop] !== 'undefined')" :propId="prop" gameId="3" :origin="limitConfig['_3'][prop][type]" v-model="mnOther[prop]" />
					<input class="form-control form-control-sm m-input" v-else-if="(prop == 1 || prop == 2) && (typeof limitConfig['_2'] !== 'undefined') && (typeof limitConfig['_2'][prop] !== 'undefined')" :propId="prop" gameId="2" :origin="limitConfig['_2'][prop][type]" v-model="mn2ddauduoi" />
					<input class="form-control form-control-sm m-input" v-else-if="(prop == 6 || prop == 7) && (typeof limitConfig['_2'] !== 'undefined') && (typeof limitConfig['_2'][prop] !== 'undefined')" :propId="prop" gameId="2" :origin="limitConfig['_2'][prop][type]" v-model="mn3ddauduoi" />
					<input class="form-control form-control-sm m-input" v-else-if="(typeof limitConfig['_2'] !== 'undefined') && (typeof limitConfig['_2'][prop] !== 'undefined')" :propId="prop" gameId="2" :origin="limitConfig['_2'][prop][type]" v-model="mnOther[prop]" />
				</td>
			</tr>
		</tbody>
	</table>
</template>

<script>
	import { mapGetters } from 'vuex';
	import { Utilities } from "../../utilities";

	export default {
		props: ["title", "type", "limitConfig"],

		data() {
			return{
				limitBacHeader: [1,2,3,4,14,17,6,7,8,9,11,12],
				limitNamHeader: [1,2,3,5,14,17,6,7,8,10,11,13],

				mb2ddauduoi: "",
				mb3ddauduoi: "",
				mbOther: [],
				mt2ddauduoi: "",
				mt3ddauduoi: "",
				mtOther: [],
				mn2ddauduoi: "",
				mn3ddauduoi: "",
				mnOther: [],
			}
		},
		watch:{
			limitConfig: function(configs){
				if(configs["_1"]){
					if(configs["_1"]["1"]) this.mb2ddauduoi = configs["_1"]["1"][this.type];
				}
				if(configs["_1"]){
					if(configs["_1"]["6"]) this.mb3ddauduoi = configs["_1"]["6"][this.type];
					let keys = Object.keys(configs["_1"]);
					for (let i = 0; i < keys.length; i++) {
						this.mbOther[keys[i]] = configs["_1"][keys[i]][this.type];
					}
				}
				if(configs["_4"]){
					if(configs["_4"]["1"]) this.mt2ddauduoi = configs["_4"]["1"][this.type];
				}
				if(configs["_4"]){
					if(configs["_4"]["6"]) this.mt3ddauduoi = configs["_4"]["6"][this.type];
					let keys = Object.keys(configs["_4"]);
					for (let i = 0; i < keys.length; i++) {
						this.mtOther[keys[i]] = configs["_4"][keys[i]][this.type];
					}
				}
				if(configs["_2"]){
					if(configs["_2"]["1"]) this.mn2ddauduoi = configs["_2"]["1"][this.type];
				}
				if(configs["_2"]){
					if(configs["_2"]["6"]) this.mn3ddauduoi = configs["_2"]["6"][this.type];
					let keys = Object.keys(configs["_2"]);
					for (let i = 0; i < keys.length; i++) {
						this.mnOther[keys[i]] = configs["_2"][keys[i]][this.type];
					}
				}
				if(configs["_3"]){
					let keys = Object.keys(configs["_3"]);
					for (let i = 0; i < keys.length; i++) {
						this.mnOther[keys[i]] = configs["_3"][keys[i]][this.type];
					}
				}
			},
		}
	}
</script>